<div class="modal-body mt-2">
  <div
    class="v-center text-center d-flex align-items-center justify-content-center"
  >
    <img
      src="assets/images/virtusa-icons/caution-red.svg"
      alt="caution"
      width="40px"
      height="40px"
    />
    <span class="header-18 mt-2"> {{ data.title }} </span>
    <div class="desc-div">
      <span class="accello-general-text14"> {{ data.description1 }} </span>
    </div>

    <span class="accello-general-text14 darker fst-italic">{{
      data.tableTitle
    }}</span>
    <div class="overflow-auto table-div">
      <app-zorro-table tableId="user-confirm" [data]="data.tableData" [columns]="data.columns">
      </app-zorro-table>
    </div>

    <div class="desc-div">
      <span class="accello-general-text14"> {{ data.description2 }} </span>
    </div>
  </div>

  <div class="d-flex justify-content-end align-items-center mt-3">
    <button
      class="btn btn-accello-secondary mx-2"
      (click)="this.activeModal.close(true)"
    >
      {{ data.button1Text }}
    </button>
    <button
      class="btn btn-accello-primary"
      (click)="onButtonClick()"
    >
      {{ data.button2Text }}
    </button>
  </div>
</div>
